// self-executing function. Will return configuration object based on environment
export default (() => {
  if (['PROD', 'STAGING'].includes(process.env.VUE_APP_ENVIRONMENT)) {
    return {
      URL_FORMATTING: {
        MODE: 'RELATIVE',
        MAPPING: [{
          from: 'information/sales_material',
          to: 'information',
        }, {
          from: 'portal.seenthis.co/information',
          to: 'communications.seenthis.co/information',
        }],
      },
    };
  } if (['LOCAL'].includes(process.env.VUE_APP_ENVIRONMENT)) {
    return {
      URL_FORMATTING: {
        MODE: 'ABSOLUTE',
        MAPPING: [],
      },
    };
  }
  throw new Error(`Unknown environment: ${process.env.VUE_APP_ENVIRONMENT}`);
})();
